import { AxiosPromise } from 'axios';
import { API } from '../../customise/constants/api';
import httpClient from './httpClient';

const { RESERVE_ONLINE, CONTINUE_IN_DEALERSHIP } = API;
const digitalApi: {
  reserveOnline: () => AxiosPromise;
  continueInDealership: () => AxiosPromise;
} = {
  reserveOnline: () => httpClient.get(RESERVE_ONLINE),
  continueInDealership: () => httpClient.get(CONTINUE_IN_DEALERSHIP),
};

export default digitalApi;
